import { StatementLineType, } from '../models';
const CREDIT_LINE_TYPES = [StatementLineType.CreditNote, StatementLineType.Prepayment, StatementLineType.Overpayment];
function sumInvoiceOutstanding(lines, overdueOnly) {
    return lines
        .filter(l => { var _a; return l.type === StatementLineType.Invoice && (!overdueOnly || ((_a = l.debtAgeInDays) !== null && _a !== void 0 ? _a : 0) > 0); })
        .reduce((acc, l) => acc + l.outstandingInCents, 0);
}
/**
 * Splits a currency section's outstanding lines into "before" (due now: invoices with
 * debt age >= splitDayIndex, plus all credit lines) and "after" (not yet due).
 * Refund lines belong to neither. Derived purely from the section, so it can run on the client.
 */
export function getStatementSplitData(section) {
    const before = [];
    const after = [];
    for (const line of section.lines) {
        if (line.type === StatementLineType.Invoice) {
            // Producers only omit debtAgeInDays for not-yet-due invoices when splitting is off, so missing means not due
            const isDue = line.debtAgeInDays !== undefined && line.debtAgeInDays >= section.splitDayIndex;
            (isDue ? before : after).push(line);
        }
        else if (CREDIT_LINE_TYPES.includes(line.type)) {
            before.push(line);
        }
    }
    const afterOutstandingGross = sumInvoiceOutstanding(after, false);
    const afterOverdueGross = sumInvoiceOutstanding(after, true);
    return {
        before: {
            lines: before,
            /** Does not include credit notes */
            totalOutstandingGrossInCents: sumInvoiceOutstanding(before, false),
            /** Does not include credit notes */
            totalOverdueGrossInCents: sumInvoiceOutstanding(before, true),
            // Section net totals already apply the org's credit-effect settings, and credits always sit in "before",
            // so the net "before" totals are the section totals minus the (credit-free) "after" totals.
            /** Includes deductions for credit notes */
            totalOutstandingInCents: section.totalOutstandingInCents - afterOutstandingGross,
            /** Includes deductions for credit notes */
            totalOverdueInCents: section.totalOverdueInCents - afterOverdueGross,
        },
        after: {
            lines: after,
            totalOutstandingGrossInCents: afterOutstandingGross,
            totalOverdueGrossInCents: afterOverdueGross,
            totalOutstandingInCents: afterOutstandingGross,
            totalOverdueInCents: afterOverdueGross,
        },
    };
}
//# sourceMappingURL=statementUtils.js.map